import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "./assets/css/base.css"
import ElementUI from 'element-ui';
import VueSeamlessScroll from "vue-seamless-scroll"
import 'element-ui/lib/theme-chalk/index.css';
import "@/assets/fonts/iconfont.css"
import XlButton from "@/components/xyhComps/XlButton.vue"

// 自定义指令
import * as directive from '@/directive';

// 设置图片服务器基准路径
Vue.prototype.baseUrl = "https://static.xueyanhui.com"
Vue.prototype.$mainColor = true
Vue.prototype.$loading = ElementUI.Loading.service;

import VueLuckyCanvas from '@lucky-canvas/vue'
Vue.use(VueLuckyCanvas)

// 过滤器
import * as filters from '@/tool/filter'
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})




Vue.directive('scroll', {
  inserted(el, binding) {
    const scrollHandler = () => {
      const scrollTop = el.scrollTop || document.documentElement.scrollTop || document.body.scrollTop;
      const scrollHeight = el.scrollHeight || document.documentElement.scrollHeight || document.body.scrollHeight;
      const clientHeight = el.clientHeight || document.documentElement.clientHeight || document.body.clientHeight;
      if (scrollTop + clientHeight >= scrollHeight - 10) {
        binding.value();
      }
    };
    el._vueScrollHandler = scrollHandler;
    el.addEventListener('scroll', scrollHandler);
  },
  unbind(el) {
    el.removeEventListener('scroll', el._vueScrollHandler);
    delete el._vueScrollHandler;
  }
});

// 全局引入公共组件
import allHead from "@/components/allHead.vue"
import logoBox from "@/components/logoBox.vue"
import baseButton from "@/components/baseButton.vue"
import topBanner from "@/components/topBanner.vue"

Vue.config.productionTip = false
Vue.component("XlButton", XlButton)
Vue.component("allHead", allHead)
Vue.component("logoBox", logoBox)
Vue.component("baseButton", baseButton)
Vue.component("topBanner", topBanner)
Vue.use(ElementUI)
Vue.use(VueSeamlessScroll)

Object.keys(directive).forEach((key) => {
  Vue.directive(key, directive[key]);
});



export default new Vue({
  router,
  store,
  beforeCreate() {
    //安装事件总线
    Vue.prototype.$EventBus = this
  },
  render: h => h(App)
}).$mount('#app');
